/** Maps a realtime event (§7: {table, id, kind, series_id?, summary}) to the cache keys it makes stale. */
import type { StreamEvent } from "../api/types";

export function keysForEvent(e: StreamEvent): string[] {
  const keys = new Set<string>(["dashboard"]);
  if (e.series_id) { keys.add(`series/${e.series_id}`); keys.add(`messages/${e.series_id}`); }
  switch (e.table) {
    case "conversation_messages":
      // Normally carries series_id (handled above). A message without one — e.g. a runner-posted Studio reply whose
      // NOTIFY payload lacks it — still refreshes every open thread rather than being dropped.
      if (!e.series_id) keys.add("messages");
      break;
    case "series": case "series_sessions": case "series_plans": case "episodes": case "jobs": case "work_items": case "work_item_events":
      keys.add("series");
      break;
    case "decisions":
      keys.add("decisions"); keys.add("series"); keys.add("version");
      break;
    case "episode_versions": case "feedback_items": case "artifacts":
      keys.add("version"); keys.add("series");
      break;
    case "learning_proposals":
      keys.add("learnings"); keys.add("series");
      break;
    case "publications": case "publication_attempts":
      keys.add("publications"); keys.add("publication"); keys.add("analytics"); keys.add("queues"); // a queue's next free slots move with its publications
      break;
    case "notifications": keys.add("notifications"); break;
    case "comments": case "reply_drafts":
      keys.add("comments");
      break;
    case "accounts": keys.add("accounts"); keys.add("publications"); keys.add("analytics"); break;
    // M5a: a sync run finished / stored YouTube data changed (table names assumed; unknown tables fall to the default).
    case "yt_sync_runs": case "youtube_data": keys.add("analytics"); keys.add("accounts"); break;
    case "settings": keys.add("settings"); keys.add("publications"); break; // the publishing pause changes every post's waiting reason
    case "schedule_queues": keys.add("queues"); break;
    case "contacts": case "share_links": keys.add("contacts"); break;
    case "runner_nodes": keys.add("health"); break;
    default:
      keys.add("series");
  }
  return [...keys];
}
